import React, { Component, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import * as dates from 'date-arithmetic'
import { Navigate } from 'react-big-calendar';
import AdvancedSearchListEvents from './AdvancedSearchListEvents';
import AdvancedSearchListEventsActions from './AdvancedSearchListEventsActions';

class WeekComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    console.log();
  }

  componentDidUpdate() {

  }

  render() {
    let { date, events, accessors, localizer } = this.props
    let { messages } = localizer
    let startWeek = dates.startOf(date, 'week', 0);
    let endOfWeek = dates.endOf(date, 'week', 0);
    events = events.filter(event => event.start >= startWeek && event.end <= endOfWeek)
    events.sort((a, b) => +accessors.start(a) - +accessors.start(b));

    const ListEventsAdvancedSearchTable = () => {
      return (
        <AdvancedSearchListEvents
          reactTableData={events}
          ReactTableActions={AdvancedSearchListEventsActions}
          setDataEvent={this.props.onSelectEvent}
          configPageSize={3}
          isAdvancedSearch={true}
        />);
    }

    return (
      <div className="rbc-agenda-view">
        {events.length !== 0 ? (
          <React.Fragment>
            <ListEventsAdvancedSearchTable />
          </React.Fragment>
        ) : (
          <span className="rbc-agenda-empty">{messages.noEventsInRange}</span>
        )}
      </div>
    );
  }
}

WeekComponent.propTypes = {
  events: PropTypes.array,
  length: PropTypes.number.isRequired,
  selected: PropTypes.object,
  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,
  localizer: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  localizer: PropTypes.any,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  scrollToTime: PropTypes.instanceOf(Date),
}

WeekComponent.navigate = (date, action, { localizer }) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return dates.add(date, -1, 'week')

    case Navigate.NEXT:
      return dates.add(date, 1, 'week')

    default:
      return date
  }
}

WeekComponent.range = date => {
  return [dates.startOf(date, 'week')]
}

WeekComponent.title = (date, { localizer }) => {
  let [start, ...rest] = WeekComponent.range(date, { localizer })
  return localizer.format({ start, end: rest.pop() }, 'dayRangeHeaderFormat')
}

export default WeekComponent;